import BaseCard from './BaseCard';
import { CardType } from './CardType';
import { BoomCardLayout } from 'Layouts/Card/MelonBomb/BoomCardLayout';
import { getLayout, GLayout } from 'Utility/layout/LayoutHelper';
import { CARD_DRAGONBONES_PATH } from 'Constants/Dragonbones';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';

export default class BoomCard extends BaseCard {
    private layout: GLayout<BoomCardLayout>;

    public onCreate(params: any): void {
        params.cardFrontTexture = 'boom_card';
        params.type = CardType.boom;
        super.onCreate(params);

        this.layout = getLayout(BoomCardLayout);
        this.layout.root.container.interactiveChildren = false;
        this.addChild(this.layout.root);
    }

    public static async preload(): Promise<void> {
        addDragonbonesResources('special_card_melon', `${CARD_DRAGONBONES_PATH}/MelonBomb/`);
    }
}
